import React from 'react';
import { SectionContainerLight } from '../common/sections/SectionContainerLight';
import { CircleLanding } from '../common/shape/CircleLanding';

export const SectionAlumni: React.FC = () => {
  return (
    <SectionContainerLight id="alumni" additionalClassName="!py-0 !my-0">
      <div className="px-8 md:px-16 py-8">
        <h2 className="text-center text-2xl md:text-3xl lg:text-4xl text-secondary-100 font-body font-bold tracking-wide mb-4 md:mb-8">
          Alumni yang Sudah Pernah Mengikuti Program Kami
        </h2>
        <div className="flex flex-col lg:flex-row items-center justify-center gap-6 md:gap-10">
          <div className="flex items-center space-x-14">
            <CircleLanding numberData="200+" subtitle="Alumni" />
            <CircleLanding numberData="50" subtitle="Recruited by Accelist" />
          </div>
          <div className="max-w-xl text-center bg-main-80 rounded-2xl shadow-[3px_7px_10px_0px_rgba(0,0,0,0.07)] p-6 md:p-8">
            <p className="text-secondary-100 text-base md:text-lg font-body font-bold" style={{ textAlign: 'justify' }}>
              200+ alumni sudah mengikuti program kami sejak tahun 2017, sekarang giliran kamu yang berkesempatan untuk menjadi lulusan berkualitas selanjutnya!
            </p>
          </div>
        </div>
      </div>
    </SectionContainerLight>
  );
};